// return authorization header with basic auth credentials
export function authHeader(contentType = null) {
  let user = JSON.parse(localStorage.getItem("user"));
  let auth = localStorage.getItem("auth");
  let check = localStorage.getItem("check") || 0;

  if (user && auth && check) {

    let header = {};

    if(!contentType){
      header = {
        'authorization': auth,
      };
    }
    else{
      header = {
        'Authorization': auth,
        'Content-Type': contentType,
        'username': user?.principal?.subject
      };
    }

    return header;

  } else {
    console.log("User or password wrong")
    window.location.replace("/logout?error=wronguser");
  }
}
